import { ReactNode } from 'react'
import { SvgIcon, SvgIconType } from '@integration-app/react'
import { ErrorData } from '@integration-app/sdk'

export default function ErrorNotification({
  error,
  children,
}: {
  error: ErrorData | Error | string
  children?: ReactNode
}) {
  const message = typeof error === 'string' ? error : error.message
  return (
    <div className={`flex items-center rounded px-2 pt-2 pb-2 bg-error bg-opacity-20 text-error`}>
      <SvgIcon type={SvgIconType.AlertOctagon} className='mr-1 middle w-5 h-5 flex-shrink-0' />
      <div className={'flex-grow'}>
        {message}
        {children && <div>{children}</div>}
      </div>
    </div>
  )
}
